import styled from "styled-components";
import {Input} from "@nextui-org/react";

const InputNext = styled(Input)`
  margin: 15px 0px;
`;

export default InputNext;
